<template>
  <div>
    <div class="fight-room">
      <!-- <div class="slide">
        <mySlide />
      </div> -->
      <div class="room-left">
        <div style="padding: 0 10px;">
          <div class="battle-title">
            <div class="room-left-hint flex flex-ac flex-jsb">
              <div>
                <span @click="goLucky">
                  <i class="iconfont" /> 返回</span>
                <!-- copyText -->
                <span class="share-btn" @click="fightResult">观看</span>
              </div>
            </div>
            <div class="room-left-box flex flex-ac">
              <div class="rond-box">
                <div class="rond-img"></div>
                <div class="rond-num">
                  <div class="l">{{ fightboxList.length }}</div>
                  <div class="price flex flex-ac flex-jc">
                    <img src="@/assets/images/money.png" class="money-img" />
                    <span>{{ fightDetail.total_price }}</span>
                  </div>
                </div>
              </div>
              <div class="roombox-warp">
                <ul class="flex flex-ac">
                  <li v-for="(item, index) in fightboxList" :key="index" @click="selImg(index)">
                    <div class="roombox-img" :class="{'roombox-img-active':index==openIndex}">
                      <span class="spoint-red">{{ index + 1 }}</span>
                      <div class="img-box">
                        <img :src="item.img_active" class="img_active" />
                        <img :src="item.img_main" class="img_main" />
                      </div>
                      <div class="flex flex-ac flex-jc">
                        <span class="price">{{ item.price }}</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="room-left-people">
          <div class="roompe-warp">
            <ul class="people-ul flex flex-jc">
              <li class="people-li" :class="'people-li'+mode" v-for="(item, index) in peopleList" :key="index" :style="'width:'+(100 / mode)+'%'">
                <div class="players-wrapper">
                  <div v-if="item.id!=0" class="player-card flex flex-ac flex-jc">
                    <div class="avatar-frame" :class="{'avatar-frame-yellow':openWin=='end'&&item.winState==1,'avatar-frame-gray':openWin=='end'&&item.winState==2}">
                      <img :src="item.img" />
                    </div>
                    <div class="win-title win-title-mobile flex-0" v-if="roomStatus!=1">
                      <img src="@/assets/images/money.png" class="money-img" />
                      <span>{{ item.totalPrice }}</span>
                    </div>
                    <div class="info-bar flex flex-jsb">
                      <div class="username flex-1">{{ item.name?item.name:'未设置' }}</div>
                      <div class="win-title win-title-pc flex-0" v-if="roomStatus!=1">
                        <img src="@/assets/images/money.png" class="money-img" />
                        <span>{{ item.totalPrice }}</span>
                        <!-- <count-to :start-val="item.beFtotalPrice?item.beFtotalPrice*1:0" :end-val="item.totalPrice*1" :duration="1000" /> -->
                      </div>
                    </div>
                  </div>
                  <div v-else class="player-card flex flex-ac flex-jc">
                    <div class="avatar-frame avatar-frame-red">
                      <div>
                        <div>
                          <i class="el-icon-plus" />
                        </div>
                        <span>等待玩家</span>
                      </div>
                    </div>
                    <div v-if="player_ids.includes(user_id+'')" class="info-bar info-bar-g flex flex-jsb">
                      <div class="username">等待中</div>
                    </div>
                    <div v-else class="info-bar info-bar-r flex flex-jsb" @click="goParticipate(index)">
                      <div class="username">加入</div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <ul v-if="openWin!='end'" class="people-ul people-line flex flex-jc">
              <div class="line">
              </div>
              <li class="people-li" :class="'people-li'+mode" v-for="(item, index) in peopleList" :key="index" :style="'width:'+(100 / mode)+'%'">
                <div class="room-warp">
                  <div class="room1">
                    <div class="pool">
                      <ul :class="{'pool-ul':openWin == 'start'}">
                        <li v-for="(itemBox, indexBox) in item.fightBox" :key="indexBox" :class="parseColor(itemBox,'color','key')">
                          <div class="pool-img flex flex-ac flex-jc">
                            <img :src="itemBox.imageUrl" />
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <ul class="people-ul people-result flex flex-jc">
              <li class="people-li" v-for="(item, index) in peopleList" :key="index" :style="'width:'+(100 / mode)+'%'">
                <div class="win-list">
                  <div class="revisionSkin-w" :class="{'avatar-frame-yellow':openWin=='end'&&item.winState==1,'avatar-frame-gray':openWin=='end'&&item.winState==2}">
                    <!-- winState 1 胜利 2失败 3 平 -->
                    <div class="room1-result">
                      <img v-if="openWin!='end'" src="@/assets/img/fight/wait.png" alt="" srcset="" class="win-list-bg">
                      <template v-else>
                        <template v-if="item.isEnd">
                          <img v-if="item.winState==1" src="@/assets/img/fight/D3f809cq.png" alt="" srcset="" class="win-list-bg">
                          <img v-else-if="item.winState==2" src="@/assets/img/fight/tYhfSjnh.png" alt="" srcset="" class="win-list-bg">
                          <img v-else-if="item.winState==3" src="@/assets/img/fight/nt4vyS9E.png" alt="" srcset="" class="win-list-bg">
                        </template>
                        <template v-else>
                          <img v-if="item.id!=0" src="@/assets/img/fight/wait-c.png" alt="" srcset="" class="win-list-bg">
                          <img v-else src="@/assets/img/fight/wait-join.png" alt="" srcset="" class="win-list-bg">
                        </template>
                      </template>
                    </div>
                    <div class="revisionSkin">
                      <!-- <ul class="win-ul"> -->
                      <transition-group tag="ul" name="item" class="win-ul">
              <li v-for="(item1, index1) in item.box" :key="item1.id||index+'a'+index1" class="skin-li win-li " style="padding-left: 0px !important;padding-right: 0px !important;" :class="parseColor(item1,'price_box','key',fightboxList[index1].price)">
                <div class="li-div li-div-center">
                  <div class="bei">
                    <img :src="item1.img" class="img_active" />
                  </div>
                  <div class="name p-2">{{ item1.name }}</div>
                  <div class="money-warp">
                    <img src="@/assets/images/money.png" class="money-img" />
                    <span>{{ item1.price }}</span>
                  </div>
                  <div class="color-line" :style="'background-color:'+parseColor(item1,'price_box','color',fightboxList[index1].price)"></div>
                </div>
              </li>
              </transition-group>
              <!-- </ul> -->
          </div>
        </div>
      </div>
      </li>
      </ul>
    </div>
  </div>
  </div>
  <audio controls ref="notify4" class="audio" loop="loop">
    <source src="@/assets/audio/open_box6s.mp3" />
  </audio>
  <!-- <myhomebot></myhomebot> -->
  </div>
  <div class="commonBg"></div>
  <box-detail-popu ref="box-detail-popu" />
  <count-game ref="count-game" @game-start="gameStart" />
  </div>

</template>

<script>
import mySlide from "@/g-components/my_slide.vue";
import myhomebot from "@/components/my_homebot.vue";
import boxDetailPopu from "@/views/fight/box-detail-popu.vue";
import { parseColor } from "@/assets/js/util.js";
import CountGame from "@/views/fight/count-game.vue";
import CountTo from 'vue-count-to'

export default {
  components: {
    myhomebot, mySlide, boxDetailPopu, CountGame, CountTo
  },
  data() {
    return {
      parseColor,
      fightDetail: {},
      fightResultArr: [],
      fightboxListNum: 0,
      fightboxList: [],
      disabled: false,
      loading: false,
      id: "",
      peopleList: [],
      peopleObj: {
        name: "等待玩家",
        id: 0,
        width: "",
        state: true,
        price: "",
        img: require("@/assets/images/moneyback.png"),
        imageUrl: require("@/assets/images/moneyback.png"),
        loading: false,
      },
      mode: "",
      boxLen: '',
      roomStatus: '',
      player_ids: [],
      user_id: '',
      // 这边用字符串 end 结束 start 开始动画 wait 等待
      openWin: 'end',
      // 这个用在标记那个箱子目前
      openIndex: -1,
    };
  },
  watch: {},
  mounted() {
    this.id = this.$route.query.id;
    this.getRoomList(true);
  },
  created() {
    if (this.$store.state.userInfo) {
      this.user_id = this.$store.state.userInfo.id;
    }
    console.log(this.user_id)
    this.initWebSocket();
  },
  destroyed() {
    //关闭
    //clearInterval(this.timer);
    this.websock.close();
  },
  methods: {
    //复制
    copyText() {
      var input = document.createElement("input"); // js创建一个input输入框
      input.value = window.location.href // 将需要复制的文本赋值到创建的input输入框中
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    //推送
    initWebSocket() {
      const domains = window.location.host.split('.')
      const wsuri = process.env.VUE_APP_WEBSOCKET == '' ? ('wss://api.' + domains[domains.length - 2] + '.' + domains[domains.length - 1] + '/ws') : process.env.VUE_APP_WEBSOCKET
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },

    websocketonopen() { },

    websocketonerror() {
      this.initWebSocket();
    },

    websocketonmessage(d) {
      console.log('收到消息了:');
      let da = JSON.parse(d.data);
      console.log('接收数据：', da)
      if (da.info) {
        this.sockBattleList(da);
      }
    },

    websocketsend(Data) {
      if (this.websock.readyState === WebSocket.OPEN) {
        this.websock.send(Data);
      }
    },
    websocketclose(e) {
      //console.log("close:", e);
    },

    sockBattleList(data) {
      console.log("推送数据->:", data.info);
      if (data.info) {
        if (data.info.id == this.id) {
          if (data.info.status != 3) {
            this.getRoomList();
          }
          if (data.info.status == 3) {
            // console.log("状态3")
            this.add = false;
          }
        }
      }
    },

    //跳转
    goLucky() {
      this.$router.push({
        path: `/fight`,
      });
    },
    //获取房间信息
    getRoomList(over) {
      this.$doGet('/api/hall.Battle/info', {
        battle_id: this.id,
      }).then((res) => {
        const data = res.data
        this.fightDetail = data
        this.player_ids = data.player_ids ? data.player_ids.split(',') : [];
        this.roomStatus = data.status
        // 处理玩家列表
        let players = data.player_info || []
        this.mode = Math.max(data.mode, players.length)
        // 填充空位
        while (players.length < this.mode) {
          players.push(this.peopleObj)
        }
        this.peopleList = players

        this.fightboxList = []
        data.boxInfo.forEach(item => {
          for (let i = 0; i < item.num; i++) {
            this.fightboxList.push(item)
          }
        })
        //对战进行中2  对战未开始1  3结束
        let box = res.data.winner_owner
        if (res.data.status == 3) {
          this.calculateFinalResults(data)
        } else if (res.data.status == 2) {
          //对战进行中
          this.fightResult()
        }
      }).catch((reason) => { })
    },
    calculateFinalResults(data) {
      const winnerOwner = data.winner_owner || []
      const rounds = data.rounds || []
      this.peopleList.forEach((p, i) => {
        p.isEnd = true;
        p.box = rounds[i] ? rounds[i].rounds.slice().reverse() : [];
        p.totalPrice = 0
        if (data.winner == 0) {
          p.winState = 3; // 平
          // 平局退回本金逻辑
          p.box.forEach(b => p.totalPrice += Number(b.price));
        } else {
          p.winState = (p.id == data.winner) ? 1 : 2; // 1赢 2输
          if (p.winState === 1) {
            winnerOwner.forEach(b => p.totalPrice += Number(b.price));
          }
        }
        p.totalPrice = Number(p.totalPrice).toFixed(2);
      })
      console.log(this.peopleList)
      this.$forceUpdate()
    },
    //房间观看对战 请求对战结果
    fightResult() {
      let param = {
        battle_id: this.id,
      };
      this.$doGet("/api/hall.Battle/resultInfo", param).then((res) => {
        res.data.result.forEach((pItem, pIndex) => {
          pItem.forEach((item, i) => {
            item.id = pIndex * this.peopleList.length + i
            item.imageUrl = item.img
            item.color = item.rarityColor
          })
        })
        this.fightResultArr = res.data.result
        this.$refs['count-game'].toggle()
        return
      }).catch((reason) => { })
    },
    gameStart() {
      this.openWin = 'wait'
      this.openIndex = -1
      this.peopleList.forEach(p => {
        p.box = []
        p.fightBox = []
        p.totalPrice = 0
        p.beFtotalPrice = 0
      })

      let fightImg = []
      //对战的滚动图片数据
      this.fightboxList.map(item => {
        if (item.skin_list.length > 0) {
          fightImg.push(item.skin_list)
        }
      })
      let imgCopy = [];
      if (fightImg.length == 1) {
        for (let i = 0; i < Math.floor(30 / fightImg[0].length) + 1; i++) {
          imgCopy = [...imgCopy, ...fightImg[0]]
          imgCopy = imgCopy.slice(0, 30);
          imgCopy = this.getRandomArr(imgCopy, 30);
        }
      } else if (fightImg.length != 1) {
        for (let i = 0; i < fightImg.length; i++) {
          for (let j = 0; j < Math.floor(30 / fightImg[i].length) + 1; j++) {
            for (let x = 0; x < fightImg[i].length; x++) {
              imgCopy.push(fightImg[i][x]);
              imgCopy = imgCopy.slice(0, 30 * (i + 1))
            }
          }
        }
      }
      this.playDong(imgCopy)
    },
    //对局结束
    over() {
      var _this = this;
      let param = {
        battle_id: this.id,
      };
      this.$doPost("/api/hall.Battle/overRoom", param).then((res) => {
        this.getRoomList()
      }).catch(() => { })
    },
    playDong(imgCopy) {
      this.openIndex = this.openIndex + 1
      let box = this.fightResultArr

      if (this.openIndex == box.length) {
        this.openIndex = -1
        this.openWin = 'end'
        this.over()
        return
      }

      // 1. 先准备数据
      this.peopleList.forEach((player, pIndex) => {
        player.fightBox = this.getRandomArr(imgCopy, 30)
        let resultObj = box[this.openIndex][pIndex]
        if (resultObj) {
          player.fightBox[0] = resultObj
          player.fightBox[25] = resultObj
        }
      })

      // 2. 重置音频
      this.$refs.notify4.currentTime = 0
      this.$refs.notify4.play()

      // 3. 【优化点】使用 nextTick 确保 DOM 更新，并稍微延迟以让浏览器渲染初始帧
      this.$nextTick(() => {
        // 可选：在这里添加一个简单的图片预加载逻辑
        // this.preloadImages(this.peopleList[0].fightBox) 

        // 4. 触发动画状态
        this.openWin = 'start'

        // 5. 动画结束后的逻辑保持不变
        setTimeout(() => {
          this.$refs.notify4.pause()
          this.openWin = 'wait' // 停止动画滚动，保持静止

          this.peopleList.forEach((player, pIndex) => {
            let resultObj = box[this.openIndex][pIndex]
            if (resultObj) {
              player.box.unshift(resultObj)
              player.beFtotalPrice = player.totalPrice
              let totalPrice = player.totalPrice * 1
              player.totalPrice = (totalPrice + Number(resultObj.price)).toFixed(2)
            }
          })
        }, 6000) // 注意：这里的时间必须与 CSS animation-duration 一致

        setTimeout(() => {
          this.playDong(imgCopy)
        }, 7000)
      })
    },

    // 新增：简单的图片预加载辅助函数（可选）
    preloadImages(list) {
      if (!list) return;
      list.forEach(item => {
        if (item.imageUrl) {
          const img = new Image();
          img.src = item.imageUrl;
        }
      });
    },

    // 打乱数组
    getRandomArr(arr, num) {
      var _arr = arr.concat();
      var n = _arr.length;
      var result = [];

      // 先打乱数组
      while (n-- && num--) {
        var index = Math.floor(Math.random() * n); // 随机位置
        [_arr[index], _arr[n]] = [_arr[n], _arr[index]]; // 交换数据
        result.push(_arr[n]); // 取出当前最后的值，即刚才交换过来的值
      }
      return result;
    },
    //点击参与活动
    goParticipate(index) {
      this.loading = true
      this.disabled = true
      let param = {
        battle_id: this.id
      };
      this.$doPost("/api/hall.Battle/joinRoom", param).then((res) => {
        this.loading = false;
        // this.$store.commit("getMoney", res.data.total_amount)
        this.$store.commit("getAboutMon", res.data)
        console.log(res)
        if (res.data.battle_status == "start") {
          let box = data.data.result
          this.mode = box.length
          this.add = true
          this.getRoomList()
        }
      }).catch((reason) => {
        this.disabled = false
        this.loading = false
      });
      // this.loading = false;
    },
    //点击盒子查看右侧图片
    selImg(index) {
      this.$refs['box-detail-popu'].toggle(this.fightboxList[index])
    },
  },
};
</script>

<style lang="less" scoped>
.fight-room {
  .audio {
    display: none;
  }
  .room-left {
    // padding: 16px 316px 0 16px;
    max-width: 1400px;
    margin: 0 auto;
    padding: 20px 0;
    .battle-title {
      margin-bottom: 20px;
      width: 100%;
      background: url(~@/assets/img/fight/room-top-bg.png);
      background-position: center;
      background-size: cover;
    }
    .room-left-hint {
      padding: 15px;
      span {
        background-color: #333542;
        color: #848492;
        padding: 9px 22px;
        border-radius: 5px;
        font-size: 15px;
        font-weight: 600;
        margin-right: 10px;
        cursor: pointer;
      }
      .share-btn {
        color: #1a1c42;
        background-color: #e9b10e;
      }
    }

    .room-left-box {
      padding: 15px;
      color: #fff;
      .rond-box {
        width: 88px;
        height: 88px;
        position: relative;
        .rond-img {
          width: 88px;
          height: 88px;
          background: url(~@/assets/img/fight/round-bg.png);
          background-size: 100% 100%;
          animation: spin 2s linear infinite;
        }
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
        .rond-num {
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .l {
            color: #fff;
            font-size: 22px;
            line-height: 28px;
          }
          .price {
            font-size: 16px;
            color: #f1c40f;
          }
        }
      }
      .roombox-warp {
        width: calc(100% - 98px);
        margin-left: 10px;
        overflow-x: auto;
        ul {
          height: 88px;
          li {
            cursor: pointer;
            .roombox-img {
              width: 70px;
              height: 80px;
              margin-right: 10px;
              // border: 2px solid #88a5c2;
              border-radius: 10px;
              background: #3b444d;
              text-align: center;
              position: relative;
              &.roombox-img-active {
                background: #9c9579;
                // background: rgb(229, 221, 181);
              }
              .spoint-red {
                position: absolute;
                top: 0px;
                font-size: 14px;
                right: 0px;
                background: red;
                border-radius: 50%;
                padding: 0 6px;
                z-index: 2;
              }
              .price {
                color: #f1c40f;
                font-size: 14px;
              }
              .img-box {
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                .img_main {
                  height: 55px;
                  width: auto;
                  max-width: 100%;
                }
                .img_active {
                  position: absolute;
                  height: 35px;
                  width: auto;
                  max-width: 100%;
                }
              }
            }
          }
        }
      }
    }

    .room-left-people {
      .roompe-warp {
        .people-ul {
          .people-li {
            .players-wrapper {
              margin-bottom: 10px;
              .player-card {
                // width: 100%;
                // position: absolute;
                // top: 0;
                // left: 0;
                // padding-top: 18%;
                flex-direction: column;
                /* 头像外框 (负责发光效果) */
                .avatar-frame {
                  width: 80px;
                  height: 80px;
                  border-radius: 12px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  color: rgb(240, 93, 93);
                  text-align: center;
                  position: relative;
                  transition: transform 0.2s;
                  font-size: 12px;
                  box-shadow: 0 0 30px rgba(52, 152, 219, 0.6); /* 蓝色发光 */
                  background: rgba(52, 152, 219, 0.1);
                  border: 2px solid rgba(52, 152, 219, 0.6);
                  &.avatar-frame-yellow {
                    box-shadow: 0 0 30px rgba(241, 196, 15, 0.8); /* 黄色强烈发光 */
                    background: rgba(241, 196, 15, 0.15);
                    border: 2px solid rgba(241, 196, 15, 0.5);
                  }
                  &.avatar-frame-gray {
                    box-shadow: 0 0 30px #88a5c2; /* 黄色强烈发光 */
                    background: #424f5c;
                    border: 2px solid #88a5c2;
                  }
                  &.avatar-frame-red {
                    box-shadow: 0 0 30px rgb(240, 93, 93); /* 黄色强烈发光 */
                    background: rgb(88, 55, 55);
                    border: 2px solid rgb(177, 65, 65);
                  }
                  img {
                    width: 64px;
                    height: 64px;
                    border-radius: 50%;
                  }
                  .el-icon-plus {
                    font-size: 32px;
                    font-weight: bold;
                    color: #fff;
                  }
                }
                /* 底部信息栏 */
                .win-title {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  span {
                    font-size: 16px;
                    color: #f1c40f;
                  }
                }
                .win-title-mobile {
                  margin-top: 6px;
                  display: none;
                }
                .info-bar {
                  margin-top: 8px;
                  background-color: #2c3e50; /* 深蓝灰色背景 */
                  padding: 6px 10px;
                  border-radius: 20px;
                  display: flex;
                  align-items: center;
                  gap: 8px;
                  font-size: 14px;
                  font-weight: 500;
                  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
                  &.info-bar-r {
                    cursor: pointer;
                    background-color: rgb(240, 93, 93);
                  }
                  &.info-bar-g {
                    cursor: pointer;
                    background-color: #f5f5f5;
                    .username {
                      color: #999;
                    }
                  }
                  .username {
                    color: #ecf0f1;
                    word-break: break-all;
                  }
                }
              }
              .room2-tou {
                width: 20%;
                height: 20%;
                margin: 0 auto;
                img {
                  width: 100%;
                  height: 100%;
                  border-radius: 50%;
                }
              }
              .join-btn {
                background: rgb(240, 93, 93);
                color: #1a1c24;
                font-size: 14px;
                font-weight: 600;
                cursor: pointer;
                padding: 5px 10px;
                border-radius: 4px;
                text-align: center;
                min-width: 30px;
              }
              .room2-price {
                padding: 0px 3.5vw;
                height: 26px;
                box-sizing: border-box;
                // margin-top: 3vw;
                .room2-name {
                  font-size: 1vw;
                  font-weight: 600;
                  color: #c3c3e2;
                  text-align: center;
                }
              }
            }
            .room-warp {
              .room1 {
                height: 200px;
                text-align: center;
                position: relative;
                overflow: hidden;
                box-sizing: border-box;
                .pool {
                  overflow: hidden;
                  position: absolute;
                  top: 0;
                  width: 100%;
                  height: 100%;
                  background-size: 100% 100%;
                  z-index: 2;
                  color: #fff;
                  ul {
                    width: 100%;
                    position: absolute;
                    top: 0;
                    animation-timing-function: linear; //动画 速度一样
                    animation-iteration-count: 1; //播放几次动画
                    animation-delay: 0s; //动画运行前等待时间
                    animation-fill-mode: forwards; //动画结束 是否保持
                    li {
                      width: 100%;
                      display: flex;
                      flex-direction: column;
                      justify-content: center;
                      background: #141414;
                      background-size: auto 100%;
                      background-position: center center;
                      background-repeat: no-repeat;
                      &.darkBlue-skin {
                        background-image: url(~@/assets/images/skin/dark_blue.png);
                      }
                      &.babyBlue-skin {
                        background-image: url(~@/assets/images/skin/baby_blue.png);
                      }
                      &.yellow-skin {
                        background-image: url(~@/assets/images/skin/yellow.png);
                      }
                      &.red-skin {
                        background-image: url(~@/assets/images/skin/red.png);
                      }
                      &.lavender-skin {
                        background-image: url(~@/assets/images/skin/lavender.png);
                      }
                      &.eggplant-skin {
                        background-image: url(~@/assets/images/skin/eggplant.png);
                      }
                      &.gray-skin {
                        background-image: url(~@/assets/images/skin/gray.png);
                      }
                      .pool-img {
                        width: 100%;
                        height: 200px;
                        color: #fff;
                        img {
                          height: 100px;
                          width: auto;
                        }
                      }
                    }
                  }
                  .pool-ul {
                    animation: run 5s;
                  }
                  @keyframes run {
                    0% {
                      top: 0;
                    }
                    100% {
                      top: -5000px;
                    }
                  }
                }
                .room1-img {
                  height: 100%;
                  background-image: linear-gradient(
                    rgba(43, 44, 55, 1),
                    rgba(35, 71, 59, 1)
                  );
                  color: #e9b10e;
                }
              }
            }
          }
        }
      }
    }
  }
  .people-line {
    position: relative;
    margin: 0 4vw;
    .line {
      position: absolute;
      width: calc(100% - 38px);
      left: 18px;
      top: calc(50% - 2px);
      border: 2px solid #c9a167;
      background: #c9a167;
      z-index: 4;
    }
    &::before {
      content: '';
      display: block;
      content: '';
      background-image: url('~@/assets/img/pointer.png');
      width: 38px;
      height: 19px;
      position: absolute;
      transform: rotate(90deg);
      background-size: 100% 100%;
      position: absolute;
      left: -9px;
      top: calc(100px - 10px);
      z-index: 10;
    }
    &::after {
      content: '';
      display: block;
      content: '';
      background-image: url('~@/assets/img/pointer.png');
      width: 38px;
      height: 19px;
      position: absolute;
      transform: rotate(270deg);
      background-size: 100% 100%;
      position: absolute;
      right: -9px;
      top: calc(100px - 10px);
      z-index: 10;
    }
  }
  //开奖列表
  .people-li .win-list {
    max-width: 350px;
    margin: 20px auto 0;
    padding: 0 5vw;
    .revisionSkin-w {
      border-radius: 12px;
      padding: 10px;
      border: 2px solid rgba(52, 152, 219, 0.6);
      &.avatar-frame-yellow {
        border: 2px solid rgba(241, 196, 15, 0.5);
      }
      &.avatar-frame-gray {
        border: 2px solid #88a5c2;
      }
      .room1-result {
        text-align: center;
        img {
          width: 50%;
          height: auto;
          margin: 0 auto;
        }
      }
    }
    .revisionSkin {
      width: 100%;
      box-sizing: border-box;
    }
    // background: url(~@/assets/img/fight/D4oLKLKS.png);
    // background-size: 100% 100%;
    // padding: 0 3vw;
    // max-height: 70vw;
    // overflow-y: auto;
    .win-ul {
      width: 100%;
      .win-li {
        width: 100%;
        .li-div {
          background-color: rgba(49, 51, 57, 0.8);
        }
      }
    }
  }
}
/* transition-group 动画类名 前缀name="item" */
.item-enter {
  /* 入场初始状态：透明+向上偏移/缩小 */
  opacity: 0;
  transform: translateY(-20px);
}
.item-enter-active {
  /* 过渡时长曲线 */
  transition: all 0.4s ease;
}
.item-enter-to {
  /* 入场结束状态 */
  opacity: 1;
  transform: translateY(0);
}

/* 如果需要删除动画可加leave系列，这里只做插入 */
</style>